import { useMutation, useQuery } from 'react-query'
import ClimaCheckService, { ClimaCheckFeedType } from '~/api/services/climaCheck'
import { onError } from '~/utils/helpers'

const getClimaChOptions = (data?) => useQuery(
  'clima-check-options',
  () => ClimaCheckService.getClimaChOptions(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getClimaCh = (data?) => useQuery(
  `clima-check-data-${data?.search}`,
  () => ClimaCheckService.getClimaChData(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getClimaChCount = (data?) => useQuery(
  `clima-check-count-${data?.search}`,
  () => ClimaCheckService.getClimaChCount(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerGroups = (id, data?) => useQuery(
  'clima-check-farmer-groups',
  () => ClimaCheckService.getClimaChFarmerGroups(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmers = (id, data?) => useQuery(
  `clima-check-farmers-${data.search}`,
  () => ClimaCheckService.getClimaChFarmers(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getClimaChEnergyData = (id, type: ClimaCheckFeedType, data?) => useQuery(
  'clima-check-energy-data',
  () => ClimaCheckService.getClimaChEnergyData(id, type, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getClimateCheckList = (enabled) => useQuery(
  'climate-check-list',
  () => enabled && ClimaCheckService.getClimateCheckList(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getClimaCheckSettingsOptions = () => useQuery(
  'clima-check-settings-options',
  ClimaCheckService.getClimaCheckSettingsOptions,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getClimaChShowData = (id: string) => useQuery(
  'clima-check-show-results-data',
  () => ClimaCheckService.getClimaChShowData(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getClimaExportOptionsData = (data?) => useQuery(
  'clima-export-options-data',
  () => ClimaCheckService.getClimaExportOptionsData(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => data.data
  }
)

const getClimaExports = (data?) => useQuery(
  'clima-exports',
  () => ClimaCheckService.getClimaExports(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => data.data
  }
)

const generateClimaExport = (onSuccess?: () => void) => useMutation(
  (data?: any) => ClimaCheckService.generateClimaExport(data),
  {
    onSuccess,
    onError,
    retry: 0
  }
)

const ClimaCheckQuery = {
  getClimaChOptions,
  getClimaCh,
  getClimaChCount,
  getFarmerGroups,
  getFarmers,
  getClimaChEnergyData,
  getClimateCheckList,
  getClimaCheckSettingsOptions,
  getClimaChShowData,
  getClimaExportOptionsData,
  getClimaExports,
  generateClimaExport
}

export default ClimaCheckQuery